export default __webpack_public_path__ + "logo-vsv-ch-31c9d75c64d153138669381c8331151d.png";